import React from "react";
import "../css/portfolio.css";
import { PortfolioData } from "./PortfolioData.js";

import Android from "../img/review/ANDROID.png";
import ios from "../img/review/iOS.png";
import app from "../img/review/APP.png";
import web from "../img/review/WEB.png";
import html5 from "../img/review/html5.png";

export default function Portfolio() {
  const typeList = [
    { name: "iOS", img: ios },
    { name: "안드로이드", img: Android },
    { name: "앱, 모바일", img: app },
    { name: "웹", img: web },
    { name: "HTML5", img: html5 },
  ];

  return (
    <section className="Portfolio">
      <div className="portfolio_inner">
        <div className="title_wrap">
          <h3>PORTFOLIO</h3>
          <strong>데이터파이브 포트폴리오</strong>
          <div>
            <ul className="typeList">
              {typeList &&
                typeList.map((type, index) => (
                  <li key={index}>
                    <img src={type.img} alt={type} />
                    <span>{type.name}</span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="portfolio_content">
          {PortfolioData &&
            PortfolioData.map((item) => (
              <a
                key={item.id}
                className="portfolio_item"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <figure>
                  <div className="image_box">
                    <img src={item.image} alt="" />
                  </div>

                  <figcaption>
                    <div className="typesBox">
                      {item.types.map((type, index) => (
                        <img key={index} src={type} alt={type} />
                      ))}
                    </div>
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </figcaption>
                  <hr />
                </figure>
              </a>
            ))}
        </div>
      </div>
    </section>
  );
}
